import { render, staticRenderFns } from "./GuangzhouUnicomJd01.vue?vue&type=template&id=45db139e&scoped=true"
import script from "./GuangzhouUnicomJd01.vue?vue&type=script&lang=js"
export * from "./GuangzhouUnicomJd01.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouUnicomJd01.vue?vue&type=style&index=0&id=45db139e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db139e",
  null
  
)

export default component.exports